/**
 * Copy and ExActionsPopUp flags for Job Category lifecycle confirms
 * (Activate / Retire / Reactivate / Archive / Unarchive), matching Department dialogs.
 */
export const JOB_CATEGORY_CONFIRM_ACTIONS = [
  "activate",
  "retire",
  "reactivate",
  "archive",
  "unarchive",
];

const COPY = {
  activate: {
    headline: "Activate Category",
    actionLabel: "Activate",
    destructive: false,
    primary: true,
    termination: false,
    info: (name) =>
      `You are about to activate Category ${name}. Once you activate, you cannot move it back to status Draft.`,
  },
  retire: {
    headline: "Retire Category",
    actionLabel: "Retire",
    destructive: false,
    primary: false,
    termination: true,
    info: (name) => `You are about to retire Category ${name}.`,
  },
  reactivate: {
    headline: "Reactivate Category",
    actionLabel: "Reactivate",
    destructive: false,
    primary: true,
    termination: false,
    info: (name) => `You are about to reactivate Category ${name}.`,
  },
  archive: {
    headline: "Archive Category",
    actionLabel: "Archive",
    destructive: true,
    primary: false,
    termination: false,
    info: (name) => `Category ${name} is about to be archived.`,
  },
  unarchive: {
    headline: "Unarchive Category",
    actionLabel: "Unarchive",
    destructive: false,
    primary: false,
    termination: false,
    info: (name) => `Category ${name} is about to be unarchived.`,
  },
};

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function confirmViewFor(action, name) {
  const key = JOB_CATEGORY_CONFIRM_ACTIONS.includes(action) ? action : "activate";
  const copy = COPY[key];
  const safeName = escapeHtml(String(name || "").trim() || "this category");
  return {
    action: key,
    headline: copy.headline,
    actionLabel: copy.actionLabel,
    destructive: copy.destructive,
    primary: copy.primary,
    termination: copy.termination,
    htmlInfo: `<div style="max-width: 414px; margin: 0 auto; margin-top: 26px;">${copy.info(
      safeName
    )}</div>`,
  };
}
